import { ComponentPropsWithoutRef } from 'react';
import { DayPicker as ReactDayPicker, PropsBase } from 'react-day-picker';

import { DateRangeStartYear } from '../../../shared/constants/date';

import 'react-day-picker/style.css';
import CustomDayPickerDropdown from './CustomDayPickerDropdown';

const formatWeekdayName = (nameOfDay: Date) =>
  nameOfDay.toLocaleDateString(undefined, {
    weekday: 'short',
  });

export function DayPicker(
  props: ComponentPropsWithoutRef<typeof ReactDayPicker>,
) {
  const classNames = {
    months: 'flex',
    weekdays: 'text-gray-400',

    month_grid:
      'border-separate border-spacing-x-1 border-spacing-y-[2px] m-auto',
    weekday:
      'w-10 h-10 text-sm text-black-700 align-middle text-center font-medium',

    day:
      ' h-10 group  text-center text-black-700 hover:bg-black-100 rounded-full focus:outline-none' +
      ' focus-visible:ring focus-visible:ring-sky-300 focus-visible:ring-opacity-50' +
      ' active:bg-sky-600 active:text-white',
    day_button:
      'font-normal  group-hover:cursor-pointer disabled:!cursor-default disabled:text-black-500' +
      ' disabled:active:text-black-500 transition-colors' +
      ' text-sm w-full h-full' +
      ' transition-colors ',
    selected: 'text-white hover:bg-blue-50 !bg-blue-700',
    today: ' bg-black-200 !font-medium text-black-900 ',
    disabled: ' hover:bg-white active:bg-white text-gray-500',
    range_middle: 'rounded-none',
    range_end: 'rounded-l-none rounded-r-full',
    range_start: 'rounded-r-none rounded-l-full',
    hidden: 'hidden',
    dropdowns: 'flex items-center gap-2 w-full justify-between',
    dropdown_root: 'relative',
    dropdown: 'sr-only',
    months_dropdown: '',
    years_dropdown: '',
    month_caption: 'flex items-center w-full justify-between mb-2 w-full',
  } satisfies PropsBase['classNames'];

  return (
    <ReactDayPicker
      animate
      formatters={{
        formatWeekdayName,
      }}
      showOutsideDays
      captionLayout="dropdown"
      startMonth={new Date(DateRangeStartYear, 0)}
      endMonth={new Date(new Date().getFullYear(), 11)}
      fixedWeeks
      classNames={classNames}
      components={{
        Nav: () => <></>,
        Dropdown: CustomDayPickerDropdown,
      }}
      {...props}
    />
  );
}
